// extracted by mini-css-extract-plugin
module.exports = {"container":"hduiUlq8j8t96WOBXqEXtg==","message":"sUwWMdyFfazEE4D+L0nR+g==","button":"CByr3E+B2Fpbk7gtXrRq6A=="};